
import axiosSync from "@/axiosSync";

export function usePortInfoGponCDATACLODEV1Api() {
  async function getGponClodeBasicInfo(olt_id) {
    const response = await axiosSync.get(`/cdata-gpon-cloude/api?oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getGponClodePonPortData(olt_id) {
    const response = await axiosSync.get(`/cdata-gpon-cloude/api?oltid=${olt_id}&dta=portdbm&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getGponClodePonPortOverViewData(olt_id) {
    const response = await axiosSync.get(`/cdata-gpon-cloude/api?oltid=${olt_id}&dta=oltponportinfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getSingleOnuData(port_number, olt_id) {
    console.log('VSOL Service - Processing:', { port_number, olt_id });
    const matches = port_number.match(/(GPON|EPON)?\d*\/(\d+):(\d+)/i);
    
    if (!matches) {
      throw new Error(`Invalid port number format: ${port_number}. Expected format like GPON0/1:1 or EPON1/1:1`);
    }
    
    const ponid = matches[2];  // The part after / and before :
    const onuid = matches[3];  // The part after :
    
    console.log('Cloud Gpon Service - Parsed:', { ponid, onuid });
    
    // const url = `vsol-epon?type=single_onudata&pon=${ponid}&onu=${onuid}&oltid=${olt_id}&url=${process.env.VUE_APP_API_BASE_URL}`;
    const url = `/cdata-gpon-cloude/api?oltid=${olt_id}&dta=onustatus&onu_id=${onuid}&pon_id=${ponid}&url=${process.env.VUE_APP_API_BASE_URL}`;
    console.log('Cloud Gpon Service - API URL:', url);
    
    const response = await axiosSync.get(url);
    console.log('Cloud Gpon Service - Response received');
    
    return response.data;
}



  return {
    getGponClodeBasicInfo,
    getGponClodePonPortData,
    getGponClodePonPortOverViewData,
    getSingleOnuData
  };
}
